"use client";

import {
    Drawer,
    DrawerClose,
    DrawerContent,
    DrawerDescription,
    DrawerFooter,
    DrawerHeader,
    DrawerTitle,
    DrawerTrigger
} from "@/components/ui/drawer";
import {Button} from "@/components/ui/button";

export default function CWFDrawer({ trigger, children, title, description, ...props }) {
    return (
        <Drawer {...props}>
            {trigger !== null && (
                <DrawerTrigger asChild>
                    {trigger ?? (
                        <Button>Drawer</Button>
                    )}
                </DrawerTrigger>
            )}
            <DrawerContent>
                <DrawerHeader className="text-left">
                    {title && <DrawerTitle>{title}</DrawerTitle>}
                    {description && <DrawerDescription>{description}</DrawerDescription>}
                </DrawerHeader>
                {/* Ajoute overflow et max-height ici */}
                <div className="px-4 pb-4 overflow-y-auto" style={{ maxHeight: 'calc(85vh - 120px)' }}>
                    {children}
                </div>
                <DrawerFooter></DrawerFooter>
            </DrawerContent>
        </Drawer>
    );
}